import { isArray } from 'lodash'
import moment from 'moment'

export function points (value) {
  return Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export function plural (singularForm, pluralForm, counter, zeroAsString) {
  if (isArray(counter)) {
    counter = counter.length
  }

  if (counter === 0) {
    if (zeroAsString) {
      return `${zeroAsString} ${singularForm}`
    }

    return `${counter} ${pluralForm}`
  }

  return `${counter} ${counter === 1 ? singularForm : pluralForm}`
}

export function currency (value) {
  value = convertStringToNumber(value)

  if (value === '') return

  const formatted = parseFloat(Math.round(value * 100) / 100)
    .toFixed(2)
    .replace(/\./g, ',')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

  return `R$ ${formatted}`
}

export function convertStringToNumber (value) {
  const res = (value && typeof value !== 'number')
    ? parseFloat(value.replace(/,/g, '.'))
    : value
  return isNaN(res) ? '' : res
}

export function formatDate (value, outputFormat) {
  return moment(value).format(outputFormat)
}
